import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { VbLxpMapComponent } from '../../map/map.component';
import { RaceSessionService } from '../../timing-tower/race-session.service';

enum Tabs {
	MAP,
	DRIVER_LIST,
}

@Component({
	selector: 'vb-lxp-map-page.component',
	imports: [VbLxpMapComponent, CommonModule],
	templateUrl: './vb-lxp-map-page.component.html',
	styleUrl: './vb-lxp-map-page.component.css',
})
export class VbLxpMapPageComponent {
	private readonly raceSessionService = inject(RaceSessionService);

	tabs = Tabs;
	currentTab = signal(Tabs.DRIVER_LIST);
	selectedDrivers = signal([]);

	readonly drivers = this.raceSessionService.raceTeamsPosition;

	onDriverClick(driver: any) {
		if (this.selectedDrivers().includes(driver.number)) {
			this.selectedDrivers.update((sd) => sd.filter((d) => d !== driver.number));
		} else {
			this.selectedDrivers.update((sd) => [...sd, driver.number]);
		}
	}
}
